import './day-of-month';
import './day-of-week';
import './day-of-year';
import './hour';
import './minute';
import './month';
import './second';
import './week';
import './week-calendar-utils';
import './year';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/bs-moment/units/index.js
// module id = 990
// module chunks = 33